// extracted by mini-css-extract-plugin
export default {"container":"_1rNk","twoRows":"_2Ki2","disabled":"VkmY","item":"_1qK_","input":"PO1O","buttons":"-sbM","wrap":"_30g9","primary":"_3vxk","spacer":"_3qRh"};